import {Tenant} from "../tenant/Tenant";

export class UserInformation {
    id: string;
    currentTenant: Tenant;
    name?: string;
    email: string;
    hasMultipleTenants: boolean;

    constructor(id: string, email: string, hasMultipleTenants: boolean, currentTenant: Tenant, name?: string) {
        this.id = id;
        this.email = email;
        this.currentTenant = currentTenant;
        this.name = name;
        this.hasMultipleTenants = hasMultipleTenants;
    }
}
